export default __webpack_public_path__ + "static/media/image-frame-1.d1a8d725.mp4";